// extracted by mini-css-extract-plugin
export default {"menuBlock":"dF-z","title":"eF-z","nav":"fF-z","flexCell":"gF-z","facetLink":"hF-z"};